
namespace GeniuzPOS.AdvPromo {
    export class AdvancedPromoReportColumns {
        static columnsKey = 'AdvPromo.AdvancedPromoReport';
    }
}